import React from 'react';

const CampusSummaryCards = ({ summary, loading }) => {
  if (loading) {
    return (
      <div className="row mb-4">
        <div className="col-md-6 mb-3">
          <div className="card h-100 shadow-sm border rounded-3">
            <div className="card-body p-4">
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '120px' }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const { totalCampuses, totalCampusesChange, totalCampusesChangePercent } = summary || {};
  const isPositive = totalCampusesChangePercent >= 0;
  const changeColor = isPositive ? '#16a34a' : '#ef4444';

  return (
    <div className="row g-4 mb-4">
      <div className="col-12 col-sm-6">
        <div className="card shadow-sm border rounded-xl position-relative overflow-hidden" style={{ transition: 'all 0.2s' }}>
          <div className="position-absolute" style={{ right: '0', top: '0', padding: '16px', opacity: '0.05', transition: 'opacity 0.2s' }}>
            <i className="bi bi-building" style={{ fontSize: '4rem', color: '#2e1065' }}></i>
          </div>
          <div className="p-4 d-flex flex-column" style={{ gap: '12px' }}>
            <p className="text-muted mb-0 small fw-medium text-uppercase" style={{ letterSpacing: '0.05em', fontSize: '0.875rem' }}>
              Total Campuses
            </p>
            <div className="d-flex align-items-baseline gap-2">
              <h2 className="mb-0 fw-bold" style={{ fontSize: '1.875rem', color: '#2e1065' }}>
                {totalCampuses || 0}
              </h2>
              {totalCampusesChange !== undefined && (
                <span 
                  className="d-flex align-items-center small fw-medium rounded"
                  style={{ 
                    backgroundColor: `${changeColor}10`,
                    color: changeColor,
                    fontSize: '0.875rem',
                    padding: '2px 6px'
                  }}
                >
                  <i className={`bi ${isPositive ? 'bi-arrow-up' : 'bi-arrow-down'}`} style={{ fontSize: '1rem', marginRight: '2px' }}></i>
                  {isPositive ? '+' : ''}{Math.abs(totalCampusesChange)}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampusSummaryCards;

